import { message } from 'antd';
import { put, takeLatest } from 'redux-saga/effects';
import { TemplateObjectType, TemplatesAPI } from 'data/templates/api';
import { deleteTemplateFromIndexedDb, getTemplateDraftFromIndexedDb } from 'hooks/use-idb';
import { logger } from 'services';
import { fetchDocumentTemplateAction } from '../actions';
import { fetchDocumentTemplateStart, fetchDocumentTemplateStartSuccess } from '../slices';
function* fetchdocumentTemplateSaga(action) {
    try {
        const { payload: { templateId } } = action;
        yield put(fetchDocumentTemplateStart({
            templateId
        }));
        let template = yield TemplatesAPI.getById(templateId);
        const dataFromIdb = yield getTemplateDraftFromIndexedDb(parseInt(String(templateId), 10));
        if (dataFromIdb != null && dataFromIdb.content != null && dataFromIdb.content.objectType === TemplateObjectType.Document) {
            var _ref, _template_publishedAt;
            if (dataFromIdb.timestamp > ((_ref = (_template_publishedAt = template.publishedAt) !== null && _template_publishedAt !== void 0 ? _template_publishedAt : template.createdAt) !== null && _ref !== void 0 ? _ref : 0) && dataFromIdb.content != null) {
                template = dataFromIdb.content;
            } else {
                yield deleteTemplateFromIndexedDb([
                    templateId
                ]);
            }
        }
        yield put(fetchDocumentTemplateStartSuccess(template));
    } catch (error) {
        logger.error('an error fetching the document', {
            error
        });
        message.error('There was an error fetching the document');
    }
}
export function* watchFetchDocumentTemplateSaga() {
    yield takeLatest(fetchDocumentTemplateAction.type, fetchdocumentTemplateSaga);
}
